/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ScheduleFrequency } from './scheduleFrequency';
import { ScheduleReport } from './scheduleReport';


export interface ReportScheduleDto { 
    id?: number;
    name?: string | null;
    isActive?: boolean;
    frequencyType?: ScheduleFrequency;
    dayOfWeek?: number | null;
    dayOfMonth?: number | null;
    customDate?: string | null;
    sendTime?: string | null;
    reports?: ScheduleReport;
    nextRunAt?: string | null;
    lastRunAt?: string | null;
    locationId?: number;
    locationName?: string | null;
    userIds?: Array<number> | null;
}
export namespace ReportScheduleDto {
}


